export default "__VITE_ASSET__cd994536__"